import {
  CATEGORY,
  CONTENT_LOADER,
  PAGE_LOADER,
  LOAD_ACTIVITY,
  QUERY_STRING,
  OFFSET_INCREMENT,
  RESET_OFFSET,
  ADD_ACTIVITY,
  SEARCH_LOADING,
  SEARCH_RESULT,
  USER_DETAILS,
  CART_DETAILS,
  CURRENCY_DETAILS,
  DESTINATIONS,
  LOCATION_SEARCH_RESULT,
  SELECTED_CATEGORY,
  QUERY_STRING_LOCATION,
  QUERY_STRING_PRICE,
  QUERY_STRING_CATEGORY,
  QUERY_STRING_DATE,
  QUERY_STRING_SORT,
  LMS_CURRENT_MODAL,
  LMS_ACTIVITY_DETAILS,
  LMS_QUERY_DETAILS,
  LMS_LOADING,
  LMS_LOAD_LOCATIONS,
  LMS_SHOW_SEARCH_RESULT,
  LMS_LIST_CATEGORIES,
  LMS_MEMBER_DETAILS,
  LMS_USER_DETAILS,
  LMS_SET_OTP,
  LMS_USER_DATA,
  QUERY_STRING_DURATION,
  QUERY_STRING_TOUR_TYPE
} from "../actions/constant";

const initialState = {
  activities: {
    activities: [],
    count: 0
  },
  offset: 0,
  category: "",
  country: {
    id: "",
    name: ""
  },
  state: {
    id: "",
    name: ""
  },
  queryString: {
    location: {
      id: null,
      name: null,
      category: null
    },
    price: {
      from: null,
      to: null
    },
    date: {
      from: null,
      to: null
    },
    type: "",
    categoryName: "",
    sort: {
      sort: "popularity",
      order: "desc"
    },
    duration: "",
    tourType: ""
  },
  pageLoader: false,
  contentLoader: false,
  searchLoading: false,
  wholePageSearchResult: [],
  locationSearchResults: [],
  user: {},
  currency: {
    current: {
      code: "INR",
      icon: "&#8377;"
    },
    list: [{
      icon: "&#36;",
      code: "USD"
    }, {
      icon: "&#8364;",
      code: "EUR"
    }]
  },
  cart: [],
  destinations: [],
  sendEnquiry: {
    currentModal: "",
    activityDetails: {},
    queryDetails: {},
    memberDetaisl: {},
    userDetails: {},
    loading: false,
    locationsSuggestions: [],
    categories: [],
    showSearch: false,
    code: [],
    userData: {}
  }
};

const reducer = function (state = initialState, action) {
  switch (action.type) {
    case QUERY_STRING:
      return { ...state,
        queryString: action.payload
      };
    case CATEGORY:
      return { ...state,
        category: action.payload
      };
    case CONTENT_LOADER:
      return { ...state,
        contentLoader: action.payload
      };
    case PAGE_LOADER:
      return { ...state,
        pageLoader: action.payload
      };
    case LOAD_ACTIVITY:
      return { ...state,
        activities: action.payload
      };
    case ADD_ACTIVITY:
      return {
        ...state,
        activities: {
          ...state.activities,
          activities: state.activities.activities.concat(action.payload)
        }
      };
    case OFFSET_INCREMENT:
      return { ...state,
        offset: state.offset + 1
      };
    case RESET_OFFSET:
      return { ...state,
        offset: 0
      };
    case SEARCH_LOADING:
      return { ...state,
        searchLoading: action.payload
      };
    case SEARCH_RESULT:
      return { ...state,
        wholePageSearchResult: action.payload
      };
    case USER_DETAILS:
      return { ...state,
        user: action.payload
      };
    case CART_DETAILS:
      return { ...state,
        cart: action.payload
      };
    case CURRENCY_DETAILS:
      return { ...state,
        currency: action.payload
      };
    case DESTINATIONS:
      return { ...state,
        destinations: action.payload
      };
    case LOCATION_SEARCH_RESULT:
      return { ...state,
        locationSearchResults: action.payload
      };
    case SELECTED_CATEGORY:
      return { ...state,
        selectedCategory: action.payload
      };
    case QUERY_STRING_LOCATION:
      return { ...state,
        queryString: { ...state.queryString,
          location: action.payload
        }
      };
    case QUERY_STRING_PRICE:
      return { ...state,
        queryString: { ...state.queryString,
          price: action.payload
        }
      };
    case QUERY_STRING_CATEGORY:
      return {
        ...state,
        queryString: {
          ...state.queryString,
          type: action.payload.type,
          categoryName: action.payload.name
        }
      };
    case QUERY_STRING_DATE:
      return { ...state,
        queryString: { ...state.queryString,
          date: action.payload
        }
      };
    case QUERY_STRING_SORT:
      return { ...state,
        queryString: { ...state.queryString,
          sort: action.payload
        }
      };
    case QUERY_STRING_DURATION:
      return { ...state,
        queryString: { ...state.queryString,
          duration: action.payload
        }
      };
    case QUERY_STRING_TOUR_TYPE:
      return { ...state,
        queryString: { ...state.queryString,
          tourType: action.payload
        }
      };
      //LMS
    case LMS_CURRENT_MODAL:
      return { ...state,
        sendEnquiry: { ...state.sendEnquiry,
          currentModal: action.payload
        }
      };
    case LMS_ACTIVITY_DETAILS:
      return { ...state,
        sendEnquiry: { ...state.sendEnquiry,
          activityDetails: action.payload
        }
      };
    case LMS_QUERY_DETAILS:
      return { ...state,
        sendEnquiry: { ...state.sendEnquiry,
          queryDetails: action.payload
        }
      };
    case LMS_LOADING:
      return { ...state,
        sendEnquiry: { ...state.sendEnquiry,
          loading: action.payload
        }
      };
    case LMS_LOAD_LOCATIONS:
      return {
        ...state,
        sendEnquiry: { ...state.sendEnquiry,
          locationsSuggestions: action.payload
        }
      };
    case LMS_SHOW_SEARCH_RESULT:
      return { ...state,
        sendEnquiry: { ...state.sendEnquiry,
          showSearch: action.payload
        }
      };
    case LMS_LIST_CATEGORIES:
      return { ...state,
        sendEnquiry: { ...state.sendEnquiry,
          categories: action.payload
        }
      };
    case LMS_MEMBER_DETAILS:
      return { ...state,
        sendEnquiry: { ...state.sendEnquiry,
          memberDetaisl: action.payload
        }
      };
    case LMS_USER_DETAILS:
      return { ...state,
        sendEnquiry: { ...state.sendEnquiry,
          userDetails: action.payload
        }
      };
    case LMS_SET_OTP:
      return {
        ...state,
        sendEnquiry: { ...state.sendEnquiry,
          code: [...state.sendEnquiry.code, action.payload]
        }
      };
    case LMS_USER_DATA:
      return { ...state,
        sendEnquiry: { ...state.sendEnquiry,
          userData: action.payload
        }
      };
    default:
      return state;
  }
};

export default reducer;